<template>
  <div>
    <h1 class="header-text">
      <span>Prijava kvara
        <div class="header-text-line"></div>
      </span>
    </h1>
    <v-container>
      <v-form v-model="valid">
        <v-flex xs12>
          <v-select
            label="Kvar primjećen u studiu"
            v-model="failure.StudioId"
            :items="studio"
            :rules="rules.required"
            item-text="Name"
            item-value="StudioId"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-textarea :rules="rules.required" label="Opis kvara" v-model="failure.Description"></v-textarea>
        </v-flex>
        <v-flex xs12 class="text-right">
          <v-btn class="main-btn" :disabled="!valid" @click="failureReport">Prijavi kvar</v-btn>
        </v-flex>
      </v-form>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      failure: {
        ReportedById: null,
        IsSolved: false
      },
      studio: [],
      valid: false,
      rules: {
        required: [v => !!v || "Polje je obavezno"]
      }
    };
  },
  methods: {
    getStudio() {
      this.$store.state.services.studioService.getAll().then(response => {
        this.studio = response.data;
      });
    },
    failureReport() {
      //Currently logged user id
      this.failure.ReportedById = parseInt(localStorage.getItem("user"));
      this.$store.state.services.failureService
        .add(this.failure)
        .then(response => {
          this.$store.dispatch("setResponseMessage", response.data);
          this.failure = {
            ReportedById: null,
            IsSolved: false
          };
        });
    }
  },
  created() {
    this.getStudio();
  }
};
</script>
